import { useEffect } from "react";
import { Grid } from "@mui/material";

import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";

import { CardDadosInformaçõesContato } from "./Components/CardDadosInformaçõesContato";
import { CardDadosPlano } from "./Components/CardDadosPlano";
import { CardProposta } from "./Components/CardProposta";
import { UseGetContractById } from "./hooks/UseGetContractById";

import { CardMetricsContracts } from "./Components/CardMetrics";

interface IContract {
  idContract: string;
}
export const Contract = ({ idContract: id }: IContract) => {
  const { dataGetByIdContrato } = useContextContrato();

  const { handleGet } = UseGetContractById();

  useEffect(() => {
    if (id) handleGet(id);
  }, [id]);

  return (
    <>
      {dataGetByIdContrato && (
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            md={9}
            spacing={2}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              order: { xs: 1, md: 0 },
            }}
          >
            <CardProposta />
            <CardDadosPlano />
            <CardDadosInformaçõesContato />
          </Grid>

          <Grid
            item
            xs={12}
            md={3}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <CardMetricsContracts id={id} />
          </Grid>
        </Grid>
      )}
    </>
  );
};
